var heading_default = {
  "fontElementMap": "J3h2G",
  "elementSpacing": "q87H1",
  "headerOne": "qMBbk q87H1",
  "headerTwo": "_0-9kb q87H1",
  "headerThree": "mV7hD q87H1",
  "headerFour": "JQTh8 q87H1",
  "headerFive": "qHr3i q87H1",
  "headerSix": "yszGl q87H1",
  "child": "kYdtu"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
